import React, { useState } from "react";
import Button from '@material-ui/core/Button';
import Axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import { colors } from "@material-ui/core"
import Backdrop from '@material-ui/core/Backdrop';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
//import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { Review } from './review'

function Alert(props) {
    return <MuiAlert elevation={0} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    value: {
        fontSize: 15,
        fontWeight: 550,
        color: colors.grey[900],
    },
    table: {
        // minWidth: 650,
    },
    details: {
        color: colors.grey[900],
        backgroundColor: colors.lime[500],
        height: 40,
    },
    textDetails: {
        fontWeight: 800,
        fontSize: 14,
        height: 10,
    },
}));

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}


export const QueryRecord = ({ formIdValue, accountNumberValue, handleReveiw, handleClosePreview, handleClickOpenQuery, handleCloseQuery, setOpenQuery, openQuery }) => {
    const classes = useStyles();

    // const [open, setOpen] = React.useState(false);
    const [disabledValue, setValue] = React.useState(false);
    const [tableData, setTableData] = useState('');
    const [openSnack, setOpenSnack] = useState(false);
    const [snackOpenError, setSnackOpenError] = useState(false);
    const handleCloseSnackBar = () => {
        setOpenSnack(false);
    };

    const handleToggleSnackBar = () => {
        setOpenSnack(true);
    };

    const handleOpenSnackError = () => {
        setSnackOpenError(true)
    }

    const handleCloseSnackError = (e, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpenError(false)
    }

    const fetchData = async () => {
        const config = {
            headers: {
                // "signature": process.env.REACT_APP_SIGNATURE,
                "signature": "64cf508d98d5dcb0d35a1e9fb6e4c278f3123b6cf1435036e6b98f4bf8aa86a6",
                "username": "KYCUI-TEST",
                "applicationID": "KYCUI",
                "where": null,
                "action": "ACC_DETAILS",
                "query": "KYC",
                "account": accountNumberValue
            },
        };

        const apiUrl = "https://192.72.53.70:5000/api/KYC/Read";
        // const apiUrl = "https://192.72.53.70/KYC/Read";
        handleToggleSnackBar();
        setValue(true)
        await Axios.get(apiUrl, config).then(res => {
            if (res.data.response_message === "Account details successfully Retrieved!") {
                setTableData(res.data.response_data);
                handleCloseSnackBar()
                handleClickOpenQuery()
                setValue(false)
            } else {
                setValue(false)
                handleCloseSnackBar()
                handleOpenSnackError()
            }
        })
        .catch(() => {
                setValue(false)
                handleCloseSnackBar()
                handleOpenSnackError();
            });
    }

    /*const fetchCore = async () => {
        handleToggleSnackBar();
        setTimeout(() => {
            handleCloseSnackBar()
            handleClickOpenQuery()
            handleOpenSnackError()
        }, 3000)
    }*/

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    const tableDataValue = tableData.length === 0 ? [] : (
        JSON.parse(tableData)
    )

    function createData(name, value) {
        return { name, value };
    }
    const postalDetails = tableDataValue.CUST_COMU_ADDR2 === ""? "........" : tableDataValue.CUST_COMU_ADDR2;
    const nokPhoneDetails = tableDataValue.NOK_PHONE === ""? "........" : tableDataValue.NOK_PHONE;
    const nokAddressDetails = tableDataValue.NOK_ADDRESSS === ""? "........" : tableDataValue.NOK_ADDRESSS;
    const rows = [
        createData('Account Name', tableDataValue.AcctName),
        createData('Account Number', tableDataValue.Account_no),
        createData('Account Branch', tableDataValue.BRANCH_NAME),
        createData('Country of Birth', tableDataValue.COUNTRY_OF_BIRTH),
        createData('Country of Residence', tableDataValue.COUNTRY_OF_RESIDENCE),
        createData('Currency', tableDataValue.Currency),
        createData('Email', tableDataValue.Email),
        createData('Phone', tableDataValue.Phone),
        createData('Signing Mandate', tableDataValue.SigningMandate),
        createData('ACCOUNT TURN OVER', tableDataValue.ACCOUNT_TURN_OVER),
        createData('ALTERNATE ACCTOR PHONE', tableDataValue.ALTERNATE_ACCTORPHONE),
        createData('ALTERNATE OPERATOR', tableDataValue.ALTERNATE_OPERATOR),
        createData('ID CARD NUMBER', tableDataValue.NAT_ID_CARD_NUM),
        createData('Postal Office NO. & Location', postalDetails),
        createData('Employer / Address', tableDataValue.CUST_COMU_ADDR1),
        createData('Current Role / Address', tableDataValue.CUST_EMP_ADDR1),
        createData('Division / District', tableDataValue.DIVISION_NAME),
        createData('Next of Kin', tableDataValue.NOK_NAME),
        createData('Next of Kin Address', nokAddressDetails),
        createData('Next of Kin Phone', nokPhoneDetails),
    ];

    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={snackOpenError}
                autoHideDuration={2000}
                onClose={handleCloseSnackError}
                key="topcenter"
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            >
                <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
                    Unable to query this account details.
                    </Alert>
            </Snackbar>
            <Backdrop className={classes.backdrop} open={openSnack}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Button variant="contained" color="default" disabled={disabledValue} onClick={fetchData}>
                Query Record
          </Button>
            <Dialog
                open={openQuery}
                onClose={handleCloseQuery}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle className={classes.details} style={{ cursor: 'move' }} id="draggable-dialog-title">
                    <span className={classes.textDetails}>Existing Record</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {/* <span className={classes.value}><li>ACCOUNT_TURN_OVER-{tableDataValue.ACCOUNT_TURN_OVER}</li></span> */}
                        <TableContainer>
                            <Table className={classes.table} size="small" aria-label="a dense table">
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.name}>
                                            <TableCell component="th" align="left" scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell className={classes.value} align="left">{row.value}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {/* <Button autoFocus onClick={handleClose} color="primary">
                Cancel
              </Button> */}
                    <Button onClick={handleCloseQuery} color="primary">
                        Cancel
              </Button>
              <Review handleToggleSnackBar={handleToggleSnackBar} handleClosePreview={handleClosePreview} 
               handleReveiw={handleReveiw} formIdValue={formIdValue} handleCloseQuery={handleCloseQuery} />
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default QueryRecord;